export default "__VITE_ASSET__VfCJ46nJ__"